/* eslint-disable @typescript-eslint/unbound-method */
import { Component, Inject, type OnInit, PLATFORM_ID } from '@angular/core';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { CmsService } from '../../shared/services/cms.service';
import { isPlatformBrowser } from '@angular/common';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { UtilService } from '../../shared/services/util.service';
import { SidePanelComponent } from '../../shared/components/side-panel/side-panel.component';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { type FormGroup, FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { type AccountDetail } from '../../shared/models/account-detail';
import { StorageEnum } from '../../shared/enums/storage.enum';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { StorageService } from '../../shared/services/storage.service';
import { MatCheckboxModule } from '@angular/material/checkbox';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { AccountService } from '../../shared/services/account.service';
import { catchError, concatMap, EMPTY } from 'rxjs';
import { NotificationComponent } from '../../shared/components/notification/notification.component';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { NotificationsService } from '../../shared/services/notifications.service';
import { NotificationType } from '../../shared/enums/notificationtype.enum';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { ErrorService } from '../../shared/services/error.service';
import { EmailFormComponent } from '../../shared/components/email-form/email-form.component';
import { EmailInfo } from '../../shared/models/email-info';
import { emailValidator } from '../../shared/validators/email.validator';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { Router, RouterModule } from '@angular/router';
import { Nav } from '../../shared/enums/nav.enum';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { Person } from '../../shared/models/person';
import { MatDividerModule } from '@angular/material/divider';
import { MatError } from '@angular/material/form-field';
import { PageHeaderComponent } from '../../shared/components/page-header/page-header.component';
import { PageHeader } from '../../shared/models/page-header.model';
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { SeoService } from '../../shared/services/seo.service';

@Component({
  selector: 'app-bill-delivery',
  imports: [
    SidePanelComponent,
    MatRadioModule,
    ReactiveFormsModule,
    MatCardModule,
    MatButtonModule,
    MatCheckboxModule,
    NotificationComponent,
    EmailFormComponent,
    MatDividerModule,
    MatError,
    PageHeaderComponent,
    RouterModule,
  ],
  templateUrl: './bill-delivery.component.html',
  styleUrl: './bill-delivery.component.scss',
})
export class BillDeliveryComponent implements OnInit {
  pageReady = false;
  pageLabels: any;
  isBrowser = false;
  sidePanelData: any = null;
  prefForm: FormGroup;
  accountDetail: AccountDetail;
  isCurrentlyOnPaperless = false;
  accountNumber = '';
  pageName = 'Bill Delivery';
  emailFormData: any = {};
  hasEmail: boolean = false;
  showInlineError = false;
  pageHeader = new PageHeader();

  constructor(
    // eslint-disable-next-line @typescript-eslint/ban-types
    @Inject(PLATFORM_ID) readonly platformId: Object,
    private readonly cms: CmsService,
    private readonly utils: UtilService,
    private readonly fb: FormBuilder,
    private readonly storage: StorageService,
    private readonly account: AccountService,
    private readonly notifi: NotificationsService,
    private readonly error: ErrorService,
    private readonly router: Router,
    private readonly seoS: SeoService,
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
    this.accountDetail = this.storage.getSession(StorageEnum.AccountDetail);
    if (this.accountDetail !== null) {
      this.isCurrentlyOnPaperless = this.accountDetail?.IsPaperlessBilling ?? false;
      this.accountNumber = this.accountDetail.AccountNumber;
    }
    this.prefForm = this.fb.group({
      preference: this.isCurrentlyOnPaperless ? 'paperless' : 'mail',
      toc: [false, [Validators.requiredTrue.bind(this)]],
    });
  }

  ngOnInit(): void {
    this.cms.getContent('oas-bill-delivery', 'Bill Delivery').subscribe((data: any) => {
      this.pageLabels = JSON.parse(JSON.stringify(data));
      this.pageHeader.Message = this.pageLabels.pageHeadline;
      this.sidePanelData = this.pageLabels.sidePanelData.value.data;
      this.seoS.setSeoTags(data.seo);

      this.hasEmail =
        this.accountDetail?.Person?.EmailAddresses?.find((email: EmailInfo) => {
          return email.IsPrimary && email.Type?.toUpperCase() === 'EMAIL';
        })?.IsPrimary ?? false;
      if (!this.hasEmail) {
        this.setupEmailData();
      }
      this.pageReady = true;
      this.utils.hideSpinner();
    });
  }

  setupEmailData(): void {
    this.emailFormData.showConfirmEmail = true;
    this.emailFormData.formGroup = this.fb.group({
      email: ['', [Validators.required, emailValidator()]],
      emailConfirm: ['', [Validators.required, emailValidator()]],
    });
  }

  changeDeliveryMethod(): void {
    const pref = this.prefForm.get('preference')?.value;
    if (
      pref === '' ||
      pref === null ||
      (pref === 'paperless' && this.isCurrentlyOnPaperless) ||
      (pref !== 'paperless' && !this.isCurrentlyOnPaperless)
    ) {
      // do nothing if they haven't made a selection or select the plan they are on
      return;
    }
    this.notifi.clearAllNotifications();
    this.showInlineError = false;
    this.utils.showSpinner();
    if (this.prefForm.valid) {
      if (pref === 'paperless') {
        // enroll in paperless
        if (!this.hasEmail) {
          // handle new email stuff
          if (this.emailFormData.formGroup.valid) {
            const emailValue = this.emailFormData.formGroup.value.email;

            const personRequest = this.accountDetail?.Person;
            const email = new EmailInfo();
            email.ContactId = '';
            email.Email = emailValue;
            email.IsActive = true;
            email.IsPrimary = true;
            email.Type = 'EMAIL';
            personRequest?.EmailAddresses?.push(email);
            this.account
              .UpdatePersonContact(personRequest)
              .pipe(
                catchError((e) => {
                  this.notifi.addNotification(this.pageLabels.emailError, NotificationType.Alert, this.pageName);
                  this.utils.hideSpinner();
                  return EMPTY;
                }),
                concatMap((data: Person) => {
                  this.accountDetail.Person = data;
                  this.accountDetail.Email = emailValue;
                  this.storage.setSession(StorageEnum.AccountDetail, this.accountDetail);
                  this.hasEmail = true;
                  return this.account.paperlessEnroll(this.accountDetail);
                }),
              )
              .subscribe({
                error: (e) => {
                  this.error.setErrorData('none', this.pageLabels.errorPageData);
                  void this.router.navigateByUrl(Nav.ErrorPage);
                },
                next: (data: any) => {
                  this.notifi.addNotification(
                    this.pageLabels.successMessage,
                    NotificationType.Postnotification,
                    this.pageName,
                  );
                  this.accountDetail.IsPaperlessBilling = true;
                  this.storage.setSession(StorageEnum.AccountDetail, this.accountDetail);
                  this.isCurrentlyOnPaperless = true;
                  this.clearChanges();
                  this.utils.hideSpinner();
                },
              });
          } else {
            const errorMessage = this.storage.getSession(StorageEnum.GlobalVars).formError;
            this.emailFormData.formGroup.markAllAsTouched();
            this.notifi.addNotification(errorMessage, NotificationType.Alert, this.pageName);
            this.utils.hideSpinner();
          }
        } else {
          this.account
            .paperlessEnroll(this.accountDetail)
            .pipe(
              catchError((e) => {
                this.error.setErrorData('none', this.pageLabels.errorPageData);
                void this.router.navigateByUrl(Nav.ErrorPage);
                return EMPTY;
              }),
            )
            .subscribe((data: any) => {
              this.notifi.addNotification(
                this.pageLabels.successMessage,
                NotificationType.Postnotification,
                this.pageName,
              );
              this.accountDetail.IsPaperlessBilling = true;
              this.storage.setSession(StorageEnum.AccountDetail, this.accountDetail);
              this.isCurrentlyOnPaperless = true;
              this.clearChanges();
              this.utils.hideSpinner();
            });
        }
      } else {
        // cancel paperless
        this.account
          .paperlessCancel(this.accountNumber)
          .pipe(
            catchError((e) => {
              this.error.setErrorData('none', this.pageLabels.errorPageData);
              void this.router.navigateByUrl(Nav.ErrorPage);
              return EMPTY;
            }),
          )
          .subscribe((data: any) => {
            this.notifi.addNotification(
              this.pageLabels.successMessage,
              NotificationType.Postnotification,
              this.pageName,
            );
            this.accountDetail.IsPaperlessBilling = false;
            this.storage.setSession(StorageEnum.AccountDetail, this.accountDetail);
            this.isCurrentlyOnPaperless = false;
            this.clearChanges();
            this.utils.hideSpinner();
          });
      }
    } else {
      this.showInlineError = true;
      const errorMessage = this.storage.getSession(StorageEnum.GlobalVars).formError;
      this.notifi.addNotification(errorMessage, NotificationType.Alert, this.pageName);
      this.utils.hideSpinner();
    }
  }

  clearChanges(): void {
    this.prefForm.get('preference')?.setValue(null);
    this.prefForm.get('toc')?.setValue(false);
  }

  async goToManageAccount(): Promise<void> {
    await this.router.navigateByUrl(Nav.ManageAccount);
  }
}
